module.exports = __webpack_public_path__ + "static/media/random.2f4eca9a.svg";